export default __webpack_public_path__ + "static/media/Camera.8d30f53a.webm";